import { createSelector } from 'reselect';
import { StoreState } from 'store/types';
import { ReturnState } from './types';

const selectSignUp = (app: StoreState): ReturnState => app.return;

export const getReturnLoading = createSelector(
  selectSignUp,
  (returns: ReturnState): ReturnState['loading'] => returns.loading
);

export const getReturnError = createSelector(
  selectSignUp,
  (returns: ReturnState): ReturnState['error'] => returns.error
);

export const getReturnErrorCode = createSelector(
  selectSignUp,
  (returns: ReturnState): ReturnState['errorCode'] => returns.errorCode
);

export const getReturnData = createSelector(
  selectSignUp,
  (returns: ReturnState): ReturnState['returnData'] => returns.returnData
);

export const getReturnPreLoading = createSelector(
  selectSignUp,
  (returns: ReturnState): ReturnState['preLoading'] => returns.preLoading
);

export const getReturnTaxRatesLoading = createSelector(
  selectSignUp,
  (returns: ReturnState): ReturnState['taxRatesLoading'] =>
    returns.taxRatesLoading
);

// New selector for returnTypesData
export const getReturnTypesData = createSelector(
  selectSignUp,
  (returns: ReturnState): ReturnState['returnTypesData'] =>
    returns.returnTypesData
);

// New selector for defaultTaxRatesData
export const getDefaultTaxRatesData = createSelector(
  selectSignUp,
  (returns: ReturnState): ReturnState['defaultTaxRatesData'] =>
    returns.defaultTaxRatesData
);

export const getTaxRatesToBoxesMapping = createSelector(
  selectSignUp,
  (returns: ReturnState): ReturnState['taxRatesToBoxesMapping'] =>
    returns.taxRatesToBoxesMapping
);

export const getAiMappingStatus = createSelector(
  selectSignUp,
  (returns: ReturnState): ReturnState['aiMappingStatus'] =>
    returns.aiMappingStatus
);